import { useCreateLicenseMutation } from "../../api/api-hooks";
import { LicenseForm } from "./licensesTypes";

const useLicensesItemCreator = () => {
  const [createLicense] = useCreateLicenseMutation();
  return (item: LicenseForm) => {
    if (!item.software || !item.hardware || !item.company || !item.license)
      return { error: { data: { message: "Missing required fields" } } };
    return createLicense({
      createLicenseDto: {
        softwareId: Number(item.software.id),
        companyId: Number(item.company.id),
        hardwareId: Number(item.hardware.id),
        moduleId: item.module ? item.module.id : null,
        orderId: item.order ? item.order.id : null,
        license: item.license,
      },
    });
  };
};

export default useLicensesItemCreator;
